import { type Variation } from '@hooks-api/types/dataModel/products'
import { type VariationsGroupByFirstLevelButton } from '../types'

/**
 * Group variations by their first_level_button. Variations with no
 * first_level_button fall into the '其他' bucket.
 */
export const groupVariationsByFirstLevelButton = (
  variations: Variation[],
): VariationsGroupByFirstLevelButton =>
  variations.reduce<VariationsGroupByFirstLevelButton>((acc, variation) => {
    const firstLevelButton = variation.first_level_button
    const key = firstLevelButton || '其他'
    if (!acc[key]) {
      acc[key] = []
    }
    acc[key].push(variation)
    return acc
  }, {})
